/* Judge.me's own list (the "all reviews" popup) includes every rating. Drop anything under
   5 stars as it arrives, including pages loaded later. */
(function () {
  const dropLow = () => {
    document.querySelectorAll('.jdgm-rev').forEach((rev) => {
      const score = rev.querySelector('.jdgm-rev__rating')?.getAttribute('data-score');
      if (score && Number(score) < 5) rev.remove();
    });
  };
  const watch = () => {
    dropLow();
    new MutationObserver(dropLow).observe(document.body, { childList: true, subtree: true });
  };
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();

/* Translates Judge.me reviews into the page language, the same way the Judge.me widget does:
   one request per batch to api.judge.me, then a toggle back to the original text. */
(function () {
  if (window.ytReviewTranslateStarted) return;

  const boot = () => {
    const root = document.querySelector('[data-yt-translate]');
    if (!root || window.ytReviewTranslateStarted) return;
    window.ytReviewTranslateStarted = true;

    const lang = (root.dataset.lang || document.documentElement.lang || '').slice(0, 2).toLowerCase();
    const shop = root.dataset.shopDomain;
    if (!lang || !shop) return;

    const showOriginal = root.dataset.showOriginal || 'Original';
    const showTranslation = root.dataset.showTranslation || 'Translation';
    let languageName = (code) => code;
    try {
      const names = new Intl.DisplayNames([lang], { type: 'language' });
      languageName = (code) => names.of(code) || code;
    } catch (error) {
      /* The language code is enough when DisplayNames is missing. */
    }

    const cards = [...document.querySelectorAll('[data-review-id]')].filter((card) => {
      const source = (card.dataset.reviewLang || '').slice(0, 2).toLowerCase();
      return card.querySelector('[data-yt-review-body]') && source !== lang;
    });
    const ids = [...new Set(cards.map((card) => card.dataset.reviewId))];
    if (!ids.length) return;

    const originals = new Map();
    cards.forEach((card) => {
      const body = card.querySelector('[data-yt-review-body]');
      originals.set(card, {
        title: card.querySelector('[data-yt-review-title]')?.textContent || '',
        body: body.innerHTML,
      });
    });

    const write = (el, text) => {
      el.replaceChildren();
      String(text).split('\n').forEach((line, index) => {
        if (index) el.append(document.createElement('br'));
        el.append(document.createTextNode(line));
      });
    };

    const apply = (card, translated, on) => {
      const title = card.querySelector('[data-yt-review-title]');
      const body = card.querySelector('[data-yt-review-body]');
      const saved = originals.get(card);
      if (on) {
        if (title && translated.title) title.textContent = translated.title;
        write(body, translated.body);
      } else {
        if (title) title.textContent = saved.title;
        body.innerHTML = saved.body;
      }
      card.dataset.translated = on ? 'true' : 'false';
      const button = card.querySelector('.yt-review__translate');
      if (!button) return;
      const source = (card.dataset.reviewLang || '').slice(0, 2).toLowerCase();
      button.textContent = on ? showOriginal.replace('{{ language }}', languageName(source)) : showTranslation;
      button.setAttribute('aria-pressed', String(on));
    };

    const toggle = (id) => {
      document.querySelectorAll(`[data-review-id="${id}"]`).forEach((card) => {
        if (!card.ytTranslation) return;
        apply(card, card.ytTranslation, card.dataset.translated !== 'true');
      });
    };

    ids.reduce((chain, id, index) => {
      if (index % 40 !== 0) return chain;
      const batch = ids.slice(index, index + 40);
      return chain.then(() =>
        fetch(
          `https://api.judge.me/api/review_translations?shop_domain=${encodeURIComponent(shop)}&language=${encodeURIComponent(lang)}&page=-1&review_uuids=${batch.join(',')}`
        )
          .then((response) => (response.ok ? response.json() : {}))
          .then((data) => {
            batch.forEach((uuid) => {
              const item = data[uuid];
              const text = item && item.body && item.body.success ? item.body.translated_text : '';
              if (!text) return;
              const translated = {
                title: item.title && item.title.success ? item.title.translated_text : '',
                body: text,
              };
              document.querySelectorAll(`[data-review-id="${uuid}"]`).forEach((card) => {
                card.ytTranslation = translated;
                const body = card.querySelector('[data-yt-review-body]');
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'yt-review__translate';
                button.addEventListener('click', () => toggle(uuid));
                body.after(button);
                apply(card, translated, true);
              });
            });
          })
          .catch(() => {})
      );
    }, Promise.resolve());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
